import { formatRecordedWindow } from '../../lib/formatRecordedWindow';

/** Compact start–end window and elapsed time; precise values on hover. */
export function RecordedWindow({
  startedAt,
  finishedAt,
  isRunning,
}: {
  startedAt: string | null;
  finishedAt: string | null;
  isRunning: boolean;
}) {
  const { label, title } = formatRecordedWindow(startedAt, finishedAt, isRunning);
  return (
    <span data-testid="run-timing" title={title} className="whitespace-nowrap">
      {label}
    </span>
  );
}
